export enum ButtonHeight {
    SMALL = '30px',
    MEDIUM = '35px',
    LARGE = '48px'
}